import middleware from './security-personel'

export default middleware
